import AuthTitle from "./AuthTitle";

export default AuthTitle;
